import tokens from './tokens'
import lpTokens from './lpTokens'
import { VaultConfig } from './types'

const vaults: VaultConfig[] = [
  {
    vid: 0,
    name: 'DMD',
    token: tokens.dmd,
    contractAddress: {
      250: '0xe1930eA19a0a17AcbBADCaAF31F49c6b8Dd2c88c',
    },
    isFinished: false,
  },
  {
    vid: 1,
    name: 'DMD / WFTM',
    token: lpTokens.dmd_wftm_lp,
    contractAddress: {
      250: '0xcdCFDDa5bF0Cb9C12A0BdC317EB52c9Aeab161d5',
    },
    strategyAddress: {
      250: '0xc6d1a60d96c1680041999ab0f2a1bdc3ced9cc8c',
    },
    isFinished: false,
    earnedToken: 'DarkMatter_DMD-FTM',
  },
  {
    vid: 2,
    name: 'DMD / FUSDT',
    token: lpTokens.dmd_fusdt_lp,
    contractAddress: {
      250: '0x94D7F3266969Dc4566490ADd018FD2b3278ceafb',
    },
    strategyAddress: {
      250: '0xd858659ec0188581393e999eddd63c94898489f6',
    },
    isFinished: false,
    earnedToken: 'DarkMatter_DMD-FUSDT',
  },
  {
    vid: 3,
    name: 'DMD / DAI',
    token: lpTokens.dmd_dai_lp,
    contractAddress: {
      250: '0x411b84A36525ff441c0a43dA3b519CBBc2387D45',
    },
    strategyAddress: {
      250: '0x8e32c880086bb79ef796a5a0311eb4a3b60251fe',
    },
    isFinished: false,
    earnedToken: 'DarkMatter_DMD-DAI',
  },
  {
    vid: 4,
    name: 'DMD / USDC',
    token: lpTokens.dmd_usdc_lp,
    contractAddress: {
      250: '0x097C6341e8AcfD686B91616BbD99C02AFec5ef2B',
    },
    strategyAddress: {
      250: '0xa027c566581ef2a361fba7d5bf72899df70e4ca4',
    },
    isFinished: false,
    earnedToken: 'DarkMatter_DMD-USDC',
  },
  // {
  //   vid: 5,
  //   name: 'APE / WFTM',
  //   token: lpTokens.ape_wftm_lp,
  //   contractAddress: {
  //     250: '0x245A7676bf9BF5a62417606bAA2aAEcE056e9710',
  //   },
  //   strategyAddress: {
  //     250: '0x0241669c22b33672A4dA8ac31e88D0f44253A6DD',
  //   },
  //   isFinished: false,
  //   earnedToken: 'DarkMatter_APE-WFTM',
  // },
  // {
  //   vid: 6,
  //   name: 'RING / USDC',
  //   token: lpTokens.ring_usdc_lp,
  //   contractAddress: {
  //     250: '0x0e4151A8a6Eb089badeDE362A3FAa2779A8940D6',
  //   },
  //   strategyAddress: {
  //     250: '0x5D49255D0C23e74Ff26c4b0Ce2a6496d079170a3',
  //   },
  //   isFinished: false,
  //   earnedToken: 'DarkMatter_RING-USDC',
  // },
  // {
  //   vid: 7,
  //   name: 'USDC / WFTM',
  //   token: lpTokens.usdc_ftm_lp,
  //   contractAddress: {
  //     250: '0xf8918709C723dd9B1CB490c0fd12d8898D866001',
  //   },
  //   strategyAddress: {
  //     250: '0xc21671AEDBEb95326bB05A3611005a54887FDCEf',
  //   },
  //   isFinished: false,
  //   earnedToken: 'DarkMatter_USDC-WFTM',
  // },
  {
    vid: 5,
    name: 'DMD / WFTM',
    token: lpTokens.dmd_wftm_lp,
    contractAddress: {
      250: '0xFD2fC9B0c3BCB02eD36987Ed6ad62974021E4be7',
    },
    strategyAddress: {
      250: '0x7aefc9d9c115327d9173756ea3bb8cdf73ce6c60',
    },
    isFinished: false,
    earnedToken: 'DarkMatter_DMD-FTM-Devil',
    subTitle: 'Uses: DevilFinance',
    withdrawalFee: '.2',
  },
]

export default vaults
